var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0733 1.34502C18.84 0.656687 18.1867 0.166687 17.4167 0.166687H4.58333C3.81333 0.166687 3.17167 0.656687 2.92667 1.34502L0.5 8.33335V17.6667C0.5 18.3084 1.025 18.8334 1.66667 18.8334H2.83333C3.475 18.8334 4 18.3084 4 17.6667V16.5H18V17.6667C18 18.3084 18.525 18.8334 19.1667 18.8334H20.3333C20.975 18.8334 21.5 18.3084 21.5 17.6667V8.33335L19.0733 1.34502ZM4.99167 2.50002H16.9967L18.2567 6.12835H3.73167L4.99167 2.50002ZM19.1667 14.1667H2.83333V8.33335H19.1667V14.1667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 13C6.7165 13 7.5 12.2165 7.5 11.25C7.5 10.2835 6.7165 9.50003 5.75 9.50003C4.7835 9.50003 4 10.2835 4 11.25C4 12.2165 4.7835 13 5.75 13Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 13C17.2165 13 18 12.2165 18 11.25C18 10.2835 17.2165 9.50003 16.25 9.50003C15.2835 9.50003 14.5 10.2835 14.5 11.25C14.5 12.2165 15.2835 13 16.25 13Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16675 22.3333H9.83342V20L16.8334 23.5H12.1667V25.8333L5.16675 22.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarProfile);
export default __webpack_public_path__ + "static/media/car-profile.f1fd6dbea2885b70d857d952f7bf1fa6.svg";
export { ForwardRef as ReactComponent };